import { render } from "./DexTabMenu.vue?vue&type=template&id=3407c6a5"
import script from "./DexTabMenu.vue?vue&type=script&lang=js"
export * from "./DexTabMenu.vue?vue&type=script&lang=js"

import "./DexTabMenu.vue?vue&type=style&index=0&id=3407c6a5&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__